import { createSelector } from '@reduxjs/toolkit';

import { specialPromosBlocksSelector } from '../specialPromosBlocks/specialPromosBlocksSelector';

export const getPhone = createSelector(specialPromosBlocksSelector, state => state.phone);
